const { DateTime } = require('luxon');

import {
  purchaseTicketWizardSteps,
  paymentTypes,
} from '@/utils/constants';

export const getDefaultState = () => {
  return {
    purchaseTicket: {
      donorDetails: {
        id: '',
        harnessId: '',
        email: '',
        firstName: '',
        lastName: '',
        fullName: '',
        phoneNumber: '',
        phoneNumberMasked: '',
      },
      existingDonor: null,
      eventDetails: {
        eventId: null,
        eventName: null,
      },
      ticketDetails: {
        ticketId: null,
        ticketPrice: null,
        ticketType: null,
      },
      paymentDetails: {
        card: null,
        monthlyDonationAmount: 50,
        cardDonationAmount: null,
        cashDonationDate: DateTime.now().toString(),
        cashDonationAmount: null,
        checkDonationDate: DateTime.now().toString(),
        checkDonationAmount: null,

        achRoutingNumber: null,
        achAccountNumber: null,
        achAccountType: 'individual',
        achConfirmedMandate: false,


        //coverProcessingFee: false,
        processingFee: null,

        // Final donation values to use
        donationAmount: null,
        donationDate: null,
        paymentType: paymentTypes.card // card, cash, check,
      },
      confirmDetails: {
        sendConfirmationToDonor: false,
        stripeToken: null,
      },
      wizardCurrentStep: purchaseTicketWizardSteps.donorDetails,
      wizardSteps: purchaseTicketWizardSteps,
      wizardStepsCount: 3,
      previousState: null,
      activeEventId: null,
      activeCharityId: null,
    },
  };
};

